var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectReviewsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 312,
    viewBox: "-5 -5 322 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1691_26904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 322,
    height: 322
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "project-reviews-inner-circle",
    cx: 106.5,
    cy: 78.6719,
    r: 6.5,
    fill: "#212036"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "project-reviews-outer-circle",
    cx: 55.5,
    cy: 274.672,
    r: 6.5,
    fill: "#212036"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 27,
    stroke: "#212036",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "project-reviews-inner-path",
    d: "M65,156a91,91 0 1,0 182,0a91,91 0 1,0 -182,0",
    stroke: "#212036",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "project-reviews-outer-path",
    d: "M1,156a155,155 0 1,0 310,0a155,155 0 1,0 -310,0",
    stroke: "#212036",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.255 146.015C150.509 145.876 150.817 145.875 151.071 146.012L156.742 149.065C157.154 149.287 157.307 149.799 157.083 150.209C156.859 150.618 156.342 150.77 155.929 150.547L150.668 147.715L145.702 150.422V152.133C145.702 152.599 145.321 152.977 144.851 152.977C144.381 152.977 144 152.599 144 152.133V149.923C144 149.616 144.169 149.332 144.441 149.184L150.255 146.015Z",
    fill: "#878CB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.594 143.104C155.85 142.965 156.159 142.965 156.415 143.104L162.546 146.447C162.818 146.596 162.987 146.879 162.987 147.187V153.237C162.987 153.703 162.606 154.081 162.136 154.081H159.349C158.879 154.081 158.498 153.703 158.498 153.237C158.498 152.771 158.879 152.394 159.349 152.394H161.285V147.685L156.004 144.806L154.714 145.51C154.303 145.734 153.785 145.585 153.559 145.177C153.332 144.769 153.482 144.256 153.894 144.032L155.594 143.104Z",
    fill: "#878CB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.128 148.82C165.355 148.412 165.872 148.263 166.284 148.487L167.561 149.184C167.833 149.332 168.002 149.615 168.002 149.923V156.58C168.002 156.89 167.831 157.175 167.555 157.322L161.403 160.611C160.99 160.832 160.474 160.679 160.251 160.269C160.027 159.859 160.182 159.348 160.596 159.127L166.301 156.077V150.422L165.464 149.966C165.052 149.741 164.902 149.228 165.128 148.82Z",
    fill: "#878CB4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.999 155.711C156.469 155.711 156.85 156.089 156.85 156.554V162.687L160.552 164.713L166.297 161.581V159.87C166.297 159.404 166.678 159.026 167.148 159.026C167.618 159.026 167.999 159.404 167.999 159.87V162.08C167.999 162.388 167.83 162.671 167.558 162.819L160.962 166.415C160.706 166.555 160.396 166.554 160.14 166.415L155.588 163.924C155.317 163.775 155.148 163.492 155.148 163.185V156.554C155.148 156.089 155.529 155.711 155.999 155.711Z",
    fill: "#878CB4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.867 157.367C150.337 157.367 150.717 157.745 150.717 158.211V164.315L155.999 167.194L156.99 166.654C157.402 166.43 157.919 166.579 158.146 166.987C158.372 167.395 158.222 167.908 157.81 168.132L156.408 168.896C156.153 169.035 155.844 169.035 155.588 168.896L149.456 165.553C149.185 165.405 149.016 165.121 149.016 164.814V158.211C149.016 157.745 149.397 157.367 149.867 157.367Z",
    fill: "#878CB4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.091 152.462C150.197 152.418 150.311 152.395 150.425 152.395H153.77C154.24 152.395 154.621 152.772 154.621 153.238C154.621 153.704 154.24 154.082 153.77 154.082H150.599L145.702 156.154V161.58L146.81 162.184C147.221 162.409 147.372 162.922 147.145 163.33C146.919 163.738 146.401 163.887 145.989 163.662L144.441 162.818C144.169 162.67 144 162.387 144 162.079V155.597C144 155.26 144.203 154.954 144.517 154.822L150.091 152.462Z",
    fill: "#878CB4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.922 156.554C152.922 156.089 153.303 155.711 153.773 155.711H158.232C158.702 155.711 159.083 156.089 159.083 156.554C159.083 157.02 158.702 157.398 158.232 157.398H153.773C153.303 157.398 152.922 157.02 152.922 156.554Z",
    fill: "#878CB4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1691_26904)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1691_26904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321 161.172C321 276.047 227.875 369.172 113 369.172C-1.87523 369.172 -95 276.047 -95 161.172C-95 46.2966 -1.87523 -46.8281 113 -46.8281C227.875 -46.8281 321 46.2966 321 161.172Z",
    fill: "url(#paint0_radial_1691_26904)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1691_26904",
    x: -114.9,
    y: -66.7281,
    width: 455.8,
    height: 455.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.95,
    result: "effect1_foregroundBlur_1691_26904"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1691_26904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 161.172) rotate(90) scale(208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#0A0219"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectReviewsImg);
export default __webpack_public_path__ + "static/media/ProjectReviewsImg.0fbbac87f272c0c5c6e01ab81ceb912b.svg";
export { ForwardRef as ReactComponent };